<template>
  <button :class="buttonClasses" :disabled="disabled" v-on="listeners">
    <template v-if="isSpinnerActive">
      <Spinner :class="spinnerClasses" />
    </template>
    <slot />
  </button>
</template>

<script>
import Spinner from './Spinner'

export default {
  name: 'SanitasButton',

  components: {
    Spinner,
  },

  props: {
    primary: {
      type: Boolean,
      default: false,
    },

    secondary: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    isSpinnerActive: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    buttonClasses() {
      return {
        'sanitas-button': true,
        'is-primary': this.primary,
        'is-secondary': !this.primary && this.secondary,
        'is-disabled': this.disabled,
        'is-spinning': this.isSpinnerActive,
      }
    },
    listeners() {
      return {
        ...(this.to
          ? { 'click.native': this.handleTap }
          : { click: this.handleTap }),
      }
    },
    spinnerClasses() {
      let classes = ['spinner']
      if (this.primary) {
        classes.push('theme--white')
      }
      if (this.secondary) {
        classes.push('theme--original-green')
      }
      return classes
    },
  },

  methods: {
    handleTap(event) {
      this.$emit('sanitas_button_tap', event) /* deprecated */
      this.$emit('click', event)
    },
  },
}
</script>

<style scoped>
.sanitas-button {
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: auto;
  min-width: 120px;
  line-height: 24px;
  padding: 10px 36px 10px 26px;
  background: none;
  border-radius: 25px;
  font-weight: bold;
  font-size: 15px;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 0.25px;
  outline: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: 'Open Sans', sans-serif;

  border: 2px solid darkred;
  background-color: lightgreen;
  color: darkred;

  .icon {
    margin-right: 10px;
    margin-top: -5px;
  }

  .spinner {
    margin: 2px 8px 0 -15px;
  }

  &:not(.is-spinning) {
    padding-left: 36px;
  }

  &.is-primary {
    background-color: #5bac26;
    border-color: #5bac26;
    color: #ffffff;

    &:disabled,
    &.is-disabled {
      background-color: #d7d7d7;
      border-color: #d7d7d7;
      color: #f1f1f1; /* equals rgba(255, 255, 255, 0.6) on #DDDDDD background */

      &:hover {
        cursor: default;
        background-color: #d7d7d7;
        border-color: #d7d7d7;
        color: #f1f1f1; /* equals rgba(255, 255, 255, 0.6) on #DDDDDD background */
      }
    }

    &.is-spinning {
      &:hover {
        cursor: default;
        background-color: #5bac26;
        border-color: #5bac26;
        color: #ffffff;
      }
    }

    &:hover {
      cursor: pointer;
      border-color: #4d8e23;
      background-color: #4d8e23;
      color: #ffffff;
    }
  }

  &.is-secondary {
    background-color: transparent;
    border-color: #5bac26;
    color: #5bac26;

    &:disabled,
    &.is-disabled {
      background-color: transparent;
      border-color: #999999;
      color: #999999;
      opacity: 0.3;

      &:hover {
        cursor: default;
        background-color: transparent;
        border-color: #999999;
        color: #999999;
      }
    }

    &.is-spinning {
      &:hover {
        cursor: default;
        background-color: transparent;
        border-color: #5bac26;
        color: #5bac26;
      }
    }

    &:hover {
      cursor: pointer;
      background-color: #5bac26;
      border-color: #5bac26;
      color: #ffffff;
      fill: #ffffff;
    }
  }
}
</style>
